







































import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { IReport } from "@/models/report.entity";
import { RepairEstimateModule } from "@/store/modules/repair-estimate.store";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import TimelineCard from "../utility/TimelineItem.vue";
import RefsRepairEstimateRequest from "../utility/RefsRepairEstimateRequest.vue";
import RepairEstimateSideCard from "@/components/repair-estimate/RepairEstimateSideCard.vue";

@Component({
  components: {
    TimelineCard,
    RefsRepairEstimateRequest,
    RepairEstimateSideCard
  }
})
export default class PartnerReportDetailRepairEstimateTimeLineElement extends mixins(PermissionMixin) {
  @Prop()
  value!: IReport;

  selectedRepairEstimate: IRepairEstimate | null = null;

  repairEstimates: IRepairEstimate[] = [];

  showAll = false;

  get title() {
    return $t("repairEstimate.repairEstimate");
  }

  async getRepairEstimate(repairEstimateId: string) {
    let repairEstimate;
    try {
      repairEstimate = RepairEstimateModule.maps.id.get(repairEstimateId)[0];
      if (!repairEstimate) {
        repairEstimate = await new RepairEstimate({
          id: repairEstimateId,
          partnerId: this.value.partnerId
        }).fetch();
      }
    } catch (error) {
      this.$log.error(error);
      return null;
    }
    return repairEstimate;
  }

  async mounted() {
    const repairEstimateHistory = [...this.value.repairEstimateHistory].sort((a, b) => {
      if (a.at > b.at) {
        return -1;
      }
      if (a.at < b.at) {
        return 1;
      }
      return 0;
    });

    for (const repairEstimateHistoryElement of repairEstimateHistory) {
      if (!repairEstimateHistoryElement?.id) {
        continue;
      }

      const repairEstimate = await this.getRepairEstimate(repairEstimateHistoryElement.id);

      if (!repairEstimate) {
        continue;
      }

      this.repairEstimates.push(repairEstimate);
    }
  }
}
